var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2200_12550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3646 2.63593C11.8498 -0.878449 6.1511 -0.87884 2.63593 2.63593C-0.87884 6.15071 -0.878449 11.8494 2.63593 15.3646C6.15071 18.8785 11.8494 18.8789 15.3646 15.3646C18.8789 11.8494 18.8785 6.1511 15.3646 2.63593ZM10.1738 12.9134C10.1738 13.2247 10.0501 13.5233 9.82996 13.7435C9.6098 13.9636 9.3112 14.0873 8.99986 14.0873C8.68851 14.0873 8.38991 13.9636 8.16975 13.7435C7.9496 13.5233 7.82592 13.2247 7.82592 12.9134V8.21762C7.82592 7.90627 7.9496 7.60768 8.16975 7.38752C8.38991 7.16736 8.68851 7.04368 8.99986 7.04368C9.3112 7.04368 9.6098 7.16736 9.82996 7.38752C10.0501 7.60768 10.1738 7.90627 10.1738 8.21762V12.9134ZM8.97911 6.21097C8.30293 6.21097 7.85213 5.732 7.86622 5.14073C7.85213 4.52089 8.30293 4.0564 8.99281 4.0564C9.68309 4.0564 10.1198 4.52128 10.1343 5.14073C10.1339 5.732 9.68348 6.21097 8.97911 6.21097Z",
    fill: "#22B573"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2200_12550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.798a95303a5c0761e6c60d0297f549db.svg";
export { ForwardRef as ReactComponent };